{
  "label_clear": "Clear",
  "label_show-error-info": "Show popup with error info"
}
